<template>
  <div v-if="page_loading">
      <loading :page_loading="page_loading" />
  </div>
  <div v-else>
    <loading :loading="loading" />
    <v-card elevation="1" class="v-card-bottom-30">
      <v-card-title  style="height: 60px;">
        <h4>purchase</h4> <v-icon>mdi-chevron-right</v-icon><span class="font-weight-regular body-1">purchase</span>
      </v-card-title>
    </v-card>

    <v-card v-for="item in tabProductList" :key="item.productMasterItemID" class="v-card-bottom-30">
      <v-card-text>
        <h3 class="pb-2">{{ use_language.product }} : {{item.productName}}</h3>

        <v-row>
          <v-col cols="12">
            <div class="px-0 v-list-item">
              <a v-if="item.photoLink != null && item.photoLink != ''" @click="OpenPhoto(item.photoLink)"
                class="v-avatar v-list-item__avatar my-0 rounded-0 v-avatar--tile"
              >
                <img :src="item.photoLink" class="picsize">
              </a>
              <div class="v-list-item__content">
                <div class="v-list-item__title subtitle-1 packhai-showproduct">
                  <div>
                    <div>{{ use_language.name_product }} </div>
                    <div> : {{ item.name }}</div>
                  </div>
                </div>
                <div>
                  <div class="v-markdown subtitle-1 packhai-showproduct">
                    <div>
                      <div>{{ use_language.type }} </div>
                      <div>
                        : {{ item.productProperty != null && item.productProperty != "" ? item.productProperty : null }}
                      </div>
                    </div>
                    <br />
                    <div>
                      <div>{{ use_language.sku }}</div>
                      <div> : {{ item.sku }}</div>
                    </div>
                    <br />
                    <div>
                      <div>{{ use_language.barcode }}</div>
                      <div> : {{ item.barcode }}</div>
                    </div>
                    <br />
                    <div v-if="item.isProductSet">
                      <div>{{ use_language.category }}</div>
                      <span class="fn-13">
                        : <v-icon size="22" color="orange darken-3" disabled>mdi-package-variant-closed-plus</v-icon>
                        {{ use_language.set_products }}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </v-col>
        </v-row>

        <v-divider class="py-2"/>
        <v-data-table 
          :headers="header_product" 
          :items="allProductList.filter(i => i.productItemId == item.productMasterItemID)[0].list"
          :items-per-page="9999999999" class="elevation-0 packhai-border-table"
          hide-default-footer
        >
          <!-- หัวตารางซ้อน -->
          <template v-slot:header>
            <thead>
              <tr>
                <th colspan="1" class="text-center" style="border-bottom: 1px solid #e9edf4">{{ use_language.date }}</th>
                <th colspan="3" class="text-center" style="border-bottom: 1px solid #e9edf4">{{ use_language.menu_orders }}</th>
                <th colspan="2" class="text-center" style="border-bottom: 1px solid #e9edf4">{{ use_language.purchase }}</th>
                <th colspan="1" class="text-center" style="border-bottom: 1px solid #e9edf4">{{ use_language.balance }}</th>
              </tr>
              <tr>
                <th></th>
                <th class="text-center">{{ use_language.menu_orders }}</th>
                <th class="text-center">{{ use_language.customer }}</th>
                <th class="text-center">{{ use_language.quantity }}</th>
                <th class="text-center">{{ use_language.bill }}</th>
                <th class="text-center">{{ use_language.quantity }}</th>
                <th></th>
              </tr>
            </thead>
          </template>

          <!-- แถวข้อมูล -->
          <template v-slot:item="{ item }">
            <tr>
              <td class="text-center" style="width:120px">
                <div v-if="item.dueDeliveryDate == null && item.calculate == null">
                  {{ use_language.date_not_specified }}
                </div>
                <div v-else-if="item.quantityStock">
                  {{ use_language.inventory }}
                </div>
                <div v-else-if="item.dueDeliveryDate">
                  {{formatDate_thai(item.dueDeliveryDate)}}
                </div>
              </td>
              <td class="text-center" style="width:100px">
                <v-btn v-if="item.orderID" style="text-decoration: underline" color="primary" text @click="order_detail_page(item.orderID)">
                  {{ format_order_id(item.orderID) }}
                </v-btn>
              </td>
              <td class="text-center" style="width:200px">{{ item.customerName }}</td>
              <td class="text-center" style="width:100px">{{ item.quantityOrderItem }}</td>
              <td class="text-center" style="width:100px">
                <v-btn v-if="item.purchaseID" style="text-decoration: underline" color="primary" text @click="purchase_detail_page(item.purchaseID)">
                  {{ format_purchase_id(item.purchaseID) }}
                </v-btn>
              </td>
              <td class="text-center" style="width:100px">{{ item.quantityPurchaseOrder }}</td>
              <td class="text-center" style="width:100px" :class="item.calculate > 0 ? 'text-success' : 'text-danger'">
                {{ item.calculate }}
              </td>
              <!-- <td :class="{'text-green': item.balance > 0, 'text-red': item.balance < 0}">
                {{ item.balance }}
              </td> -->
            </tr>
          </template>
    
          <!-- <template v-slot:item.dueDeliveryDate="{ item }">
            <div v-if="item.dueDeliveryDate == null && item.calculate == null">
              ยังไม่ระบุวันที่
            </div>
            <div v-else-if="item.quantityStock">
              สต๊อกคงเหลือ
            </div>
            <div v-else-if="dueDeliveryDate">
              {{formatDate_thai(item.dueDeliveryDate)}}
            </div>
          </template>
          <template v-slot:item.orderID="{ item }">
            <v-btn v-if="item.orderID" style="text-decoration: underline" color="primary" text @click="order_detail_page(item.orderID)">
              {{ format_order_id(item.orderID) }}
            </v-btn>
          </template>
          <template v-slot:item.purchaseID="{ item }">
            <v-btn v-if="item.purchaseID" style="text-decoration: underline" color="primary" text @click="purchase_detail_page(item.purchaseID)">
              {{ format_purchase_id(item.purchaseID) }}
            </v-btn>
          </template> -->
        </v-data-table>
      </v-card-text>
    </v-card>

    <!-- แสดงภาพ -->
    <v-dialog v-model="showPhoto" max-width="500">
      <v-card class="ma-0">
        <v-card-text>
          <v-row align="center">
            <v-col cols="12" class="text-center">
              <img class="hidden-md-and-up" :src="showPhotoLink" width="300">
              <img class="hidden-sm-and-down" :src="showPhotoLink" width="450">
            </v-col>
          </v-row>
        </v-card-text>
        <v-divider />
        <v-card-actions>
          <v-btn text color="#1976d2" @click="Opentap(showPhotoLink)">{{ use_language.newtab }}</v-btn>
          <v-spacer></v-spacer>
          <v-btn text color="#1976d2" @click="showPhoto = false">{{ use_language.close }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

  </div>
</template>

<script>

import Loading from '@/website/components/Loading'
import axios from 'axios'
import { orderService_dotnet } from '@/website/global'
import { format_number, format_order_id, formatDate_thai, format_purchase_id, get_languages } from '@/website/global_function'

export default {
  name: 'FrontShopReportPurchase',

  components: { Loading },

  data() {
    return {
      header_token:{'Content-Type': 'application/json', 'Authorization': 'Bearer '+localStorage.getItem('authorization_token')},
      shop_id: localStorage.getItem('shop_id'),
      page_loading: true,
      loading: false,
      use_language: null,
      set_language: null,

      //
      tab: null,
      allProductList: [],
      tabProductList: [],
      header_product: [],
      showPhoto: false,
      showPhotoLink: '',
      
    };
  },

  mounted() {
    
  },

  async created() {
    await this.getOrderPurchaseStock()
    this.use_language = await this.get_languages(localStorage.getItem("set_language"));
    this.page_loading = false
  },
  

  methods: {
    format_number, format_order_id, formatDate_thai, format_purchase_id, get_languages,
    async getOrderPurchaseStock() {
      this.loading = true

      let response = await axios.post(
        orderService_dotnet + 'PO/get-order-purchase-quantity',
        // 'https://localhost:5001/PO/get-order-purchase-quantity',
        // 'https://dev-order.packhai-api-88.com/PO/get-order-purchase-quantity',
        { "shopID": this.shop_id },
        {headers: this.header_token}
      )
      var res = response.data
      this.tabProductList = res.productList

      res.productList.forEach(e => {
        var haveDate = res.haveDueDateList.filter(i => i.productMasterItemID == e.productMasterItemID)
        var noDate = res.noDueDateList.filter(i => i.productMasterItemID == e.productMasterItemID)
        var stock = res.stockList.filter(i => i.productMasterItemID == e.productMasterItemID)

        var merge1 = noDate
        merge1 = merge1.concat(stock)
        var merge2 = merge1.concat(haveDate)

        var calculate = 0
        merge2.forEach(e2 => {
          if (e2.quantityStock != null) {
            calculate = e2.quantityStock
            e2.calculate = calculate
          } else if (e2.dueDeliveryDate != null && e2.purchaseID != null) {
            calculate = calculate + e2.quantityPurchaseOrder
            e2.calculate = calculate
          } else if (e2.dueDeliveryDate != null && e2.orderID != null) {
            calculate = calculate - e2.quantityOrderItem
            e2.calculate = calculate
          }
        });

        this.allProductList.push({
          'productItemId': e.productMasterItemID,
          "list": merge2
        })
      });

      this.loading = false
    },
    order_detail_page(id) {
      window.open('order-detail?id=' + id, '_blank');
    },
    purchase_detail_page(id) {
      window.open("addPurchase?id=" + id, '_blank');
    },
    OpenPhoto(Photo) {
      this.showPhotoLink = Photo
      this.showPhoto = true
    },
    Opentap(PhotoLink) {
      window.open(PhotoLink);
    },
  },
};
</script>

<style scoped>
.my-table table {
  border-collapse: collapse;
  width: 100%;
}

.my-table th,
.my-table td {
  border: 1px solid #000000;
  padding: 6px 10px;
  text-align: center;
}
</style>